module.exports = __webpack_public_path__ + "img/followers.ab42df81.svg";